<template>
    <ul class="skeleton-lines">
        <li class="skeleton-lines__line" v-for="line in lines"></li>
    </ul>
</template>

<script>
    export default {
        name: 'skeleton-lines',
        props: ['lines'],
    };
</script>

<style>
    .skeleton-lines {
        display: block;
        width: 100%;
    }

    .skeleton-lines .skeleton-lines__line:last-child {
        margin-bottom: 0;
    }

    .skeleton-lines__line {
        background-color: rgba(0, 0, 0, .05);
        height: 14px;
        width: 100%;
        padding: 4px;
        display: block;
        margin-bottom: 6px;
        border-radius: 3px;
    }
</style>



// WEBPACK FOOTER //
// SkeletonLines.vue?da7a4466